import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CONSTANTS } from 'src/app/constants';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(
    private router: Router
  ) { }

  async navigateFromHome(route: string): Promise<void> {
    await this.router.navigateByUrl(`${CONSTANTS.ROUTES.HOME}/${route}`);
  }

  async navigateFromMissionConfig(route: string): Promise<void> {
    await this.navigateFromHome(`${CONSTANTS.ROUTES.MISSION_CONFIG}/${route}`);
  }

  isCurrentUrlFromHome(route: string): boolean {
    return this.router.url.includes(`${CONSTANTS.ROUTES.HOME}/${route}`);
  }
}